<template>
  <div class="modal fade" id="createBillRun" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-9 col-sm-5 col-lg-5 my-auto">
                <h5 class="modal-title" id="createBillRunLabel">New Bill</h5>
              </div>
              <div class="col-3 col-sm-7 my-auto">
                <div>
                  <div>
                    <span>
                      <a class="close">
                        <i
                          class="far fa-times-circle fa-2x"
                          data-dismiss="modal"
                          id="closeCreateBill"
                          aria-label="Close"
                        ></i>
                      </a>
                    </span>
                  </div>
                  <div>
                    <!-- <router-link :to="{ path: '/dashboard'}" target="_blank">
                                <span class="fa-stack fa-2x fsm float-right">
                                    <i class="far fa-circle fa-stack-2x"></i>
                                    <i class="fas fa-external-link-alt fa-stack-1x"></i>
                                </span>
                    </router-link>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-sm-4 col-md-4 col-lg-3">
                    <p>Bill to:</p>
                  </div>
                  <div class="col-sm-8 col-md-8 col-lg-6">
                    <div>
                      <el-date-picker
                        v-model="pickerDate"
                        :picker-options="pickerOptions"
                        format="dd.MM.yyyy"
                        value-format="yyyy-MM-dd"
                        class="float-right"
                        type="date"
                        placeholder="Select an end date"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            @click="submit()"
            class="btn btn-hc"
            :disabled="submitStatus == 'PENDING'"
          >
            Start
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Swal from 'sweetalert2';
import Vue from 'vue';

// Mixins
import snotifyHttpError from '@/mixins/snotifyHttpResponses';

export default {
  mixins: [snotifyHttpError],
  data() {
    return {
      pickerDate: moment().format('YYYY-MM-DD'),
      pickerOptions: {
        disabledDate: (date) => {
          return date > moment();
        },
      },
      submitStatus: null,
    };
  },

  computed: {
    url() {
      return `https://${
        Vue.config.honeycomb.billbotbillrun.domain
      }/api/v1/now/`;
    },

    logbot() {
      return `https://${Vue.config.honeycomb.logbot.domain}`;
    },

    dto() {
      return {
        BillToDate: this.pickerDate
          ? moment.utc(this.pickerDate).format()
          : undefined,
        Customers: [this.$store.state.customers.customer.Id],
        BillingGroups: [],
      };
    },
  },

  methods: {
    submit() {
      if (!this.pickerDate) {
        this.$snotify.warning(`Warning! Please provide a date to bill to.`);
        return false;
      }

      this.submitStatus = 'PENDING';
      document.getElementById('closeCreateBill').click();

      this.$snotify.async(
        'Creating bill...',
        () =>
          new Promise((resolve, reject) => {
            this.createBill()
              .then((response) => {
                this.submitStatus = 'OK';
                this.pickerDate = moment().format('YYYY-MM-DD');
                Swal({
                  title: 'New Bill Created!',
                  type: 'success',
                  confirmButtonText: 'View Bill',
                  confirmButtonColor: Vue.config.honeycomb.colour,
                  showCancelButton: true,
                  cancelButtonText: 'Close',
                }).then((result) => {
                  if (result.value) {
                    const documentUri = this.$_.findWhere(this.$store.state.finances.bills, {
                      BillRunId: response.data.BillRunId,
                    }).SalesTransaction.DocumentUri;

                    const urlParts = documentUri.split('/');
                    const statementId = urlParts[urlParts.length - 2];

                    this.$http
                      .get(
                        `https://${Vue.config.honeycomb.billbotstatements.domain}/api/v1/statements/${statementId}/uri`,
                        { withCredentials: true }
                      )
                      .then((stmtResponse) => {
                        window.open(stmtResponse.data.url, '_blank');
                      })
                      .catch((error) => {
                        this.$snotify.error(
                          `Error viewing statement: ${(error.response && error.response.data && error.response.data.UserDescription) || error.message}`,
                          { timeout: 0, closeOnClick: true }
                        );
                      });
                  }
                });

                this.pickerDate = moment().format('YYYY-MM-DD');
                this.$store.dispatch('getBills');
                this.$store.dispatch('getLedger');
                this.$store.dispatch('getCharges');
                this.$store.dispatch('getUsage');
                this.$store.dispatch('refreshReadings');
                setTimeout(() => {
                  this.$store.dispatch('refreshCustomer');
                }, 3000);
                resolve({
                  body: 'Success! New Bill Created!',
                  config: {
                    closeOnClick: true,
                    timeout: 2000,
                  },
                });
              })
              .catch((error) => {
                // Error
                this.submitStatus = 'ERROR';
                reject(this.snotifyHttpError(error));
              });
          })
      );
    },

    async createBill() {
      const res = await this.$http.post(this.url, this.dto, {
        withCredentials: true,
      });
      this.submitStatus = 'OK';

      const {
        CustomersSuccessful,
        CustomersOnHold,
        CustomersSkipped,
        CustomersFailed,
        HasFailed,
        BillRunId,
      } = res.data;

      if ((CustomersSuccessful || CustomersOnHold) && !HasFailed) return res;

      if (CustomersSkipped && !HasFailed) {
        this.noBillCreatedMessage();
        throw new Error('Unable to create bill!');
      }

      if (CustomersFailed && !HasFailed) {
        const log = await this.getLog(BillRunId);
        this.errorMessage(log);
        throw new Error(log.Message);
      }
    },

    // This will try loading the logs a few times as they won't exist immediately
    async getLog(id, delay = 500) {
      if (delay > 32000) return; // if delay is to large give up
      await new Promise((res) => setTimeout(() => res(), delay));

      const url = `${this.logbot}/api/v1/Messages/${id}`;
      const { data: log } = await this.$http.get(url);

      if (log && log[0]) return log[0];

      return await this.getLog(id, delay * 2);
    },

    noBillCreatedMessage() {
      Swal(
        'No Bill Created!',
        "This is most likely because the customer's services have been set to not bill or a bill for the requested date already exists.",
        'warning'
      );
    },

    errorMessage(log) {
      Swal('No Bill Created!', log.Guidance, 'error');
    },
  },
};
</script>
